import { Injectable } from '@angular/core';
import { isUndefined } from '@sama/micro-dash';
import { Observable, Subject } from 'rxjs';
import { AbstractTool } from '../../../../cross-team-shared/annotation/shared/abstract-tool';
import { ImageContentState } from '../../state/image-content-state';
import { ImageContentStore } from '../../state/image-content-store';

@Injectable()
export class ColorSelectTool extends AbstractTool<
  ImageContentState,
  ImageContentStore
> {
  readonly name = 'ColorSelect';
  private revealColor$ = new Subject<number>();

  override async onActivate() {
    await super.onActivate();
    this.onEvent('container', 'click', () => this.selectColor());
  }

  getRevealColor$(): Observable<number> {
    return this.revealColor$.asObservable();
  }

  private selectColor() {
    const hoveredColor = this.store.getHoveredColor();

    if (isUndefined(hoveredColor)) {
      return;
    }

    this.store('selectedTagOptionCode').set(hoveredColor.code);
    this.revealColor$.next(hoveredColor.code);

    this.shellConnector.trackEvent({
      id: 'select_raster_coding_layer_label',
      bucket: 'tag_selection',
      label: hoveredColor.label,
      code: hoveredColor.code,
      source: 'edit_tool',
    });
  }
}
